module.exports = __webpack_public_path__ + "img/pair-success.786e9e5b.gif";